import { isExpEditor } from '../lib/lib'

class Wallet {
  constructor(element) {
    if (!element) {
      return false
    }

    console.log('enter')

    if (isExpEditor()) {
      return false
    }

    this.wallet = jQuery(element)
    this.getMobileOperatingSystem()
  }

  getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {    
      this.wallet.find('.b-wallet__mob__android').removeClass('hide')
      //return '.windows'
    }

    if (/android/i.test(userAgent)) {   
      this.wallet.find('.b-wallet__mob__android').removeClass('hide')
      // return '.android'
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      this.wallet.find('.b-wallet__mob__ios').removeClass('hide')
      //return '.ios'
    }

    // return '.unknown'
  }
}
export default Wallet
